import React from 'react';
import { Input } from '@/components/ui/input';

interface PhoneInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  value?: string;
  onChange?: (value: string) => void;
}

export function PhoneInput({ value, onChange, ...props }: PhoneInputProps) {
  // Format phone number as user types
  const formatPhoneNumber = (input: string) => {
    // Remove all non-digits
    const numbers = input.replace(/\D/g, '');
    
    if (!numbers) return '';
    
    // Format based on length
    if (numbers.length <= 2) {
      return `(${numbers}`;
    }
    if (numbers.length <= 7) {
      return `(${numbers.slice(0, 2)}) ${numbers.slice(2)}`;
    }
    if (numbers.length <= 11) {
      return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7)}`;
    }
    // Limit to 11 digits
    return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7, 11)}`;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    
    // If input is empty or just a parenthesis, allow it to be cleared
    if (!inputValue || inputValue === '(') {
      onChange?.('');
      return;
    }

    // Format the phone number
    const formattedValue = formatPhoneNumber(inputValue);
    onChange?.(formattedValue);
  };

  return (
    <Input
      {...props}
      type="tel"
      value={value || ''}
      onChange={handleChange}
      placeholder="(00) 00000-0000"
    />
  );
}